"use strict";

import angular from "angular";

export class AccountingDataService {
    entity = {};

    constructor() {}

    setEntity(entity) {
        this.entity = entity;
    }

    getEntity() {
        return this.entity;
    }
}

angular
    .module("nucont.shared")
    .factory("AccountingDataService", [AccountingDataService]);
